import Swiper, { Autoplay, Navigation, Thumbs, EffectCreative } from 'swiper';

let studiesFirstSwiperWr = document?.querySelectorAll('.reviews-swiper-wr');

studiesFirstSwiperWr.forEach((swiperWr) => {
  if (swiperWr) {
    const thumbsSliderEl = swiperWr.querySelector('.reviews-slider'),
          mainSliderEl = swiperWr.querySelector('.reviews-pagination');

    if (thumbsSliderEl && mainSliderEl) {

      let mainSwiper;
      const mainSliderSlides = mainSliderEl.querySelectorAll('.swiper-slide');
      
      // cards slider
      const thumbsSwiper = new Swiper(thumbsSliderEl, {
        modules: [Navigation],
        observer: true,
        observeParents: true,
        spaceBetween: 16,
        slidesPerView: 1,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        breakpoints: {
          1200: {
            spaceBetween: 24,
          },
        },
        on: {
          slideChange: function() {
            mainSwiper?.slideTo(this.realIndex, 500, false);
          },
        },
      });


      // users slider
      let nextEl = mainSliderEl.parentElement.querySelector('.swiper-button-next');
      let prevEl = mainSliderEl.parentElement.querySelector('.swiper-button-prev');

      console.log(nextEl);
      

      mainSwiper = new Swiper(mainSliderEl, {
        modules: [Autoplay, Thumbs, EffectCreative, Navigation],
        observer: true,
        observeParents: true,
        // slidesPerView: 1,
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: false,
        initialSlide: mainSliderSlides.length / 2,
        autoplay: {
          delay: 800000,
          disableOnInteraction: false,
        },
        thumbs: {
          swiper: thumbsSwiper,
        },

        effect: 'creative',
        centeredSlides: true,
        creativeEffect: {
          limitProgress: window.innerWidth >= 640 ? 3 : 2,
          perspective: true,
          prev: {
            translate: ['-45%', 0, 0],
            scale: 1,
            opacity: 1,
          },
          next: {
            translate: ['45%', 0, 0],
            scale: 1,
            opacity: 1,
          },
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        on: {
          slideChange: function(swiper) {
            thumbsSwiper.slideTo(swiper.realIndex, 500, false);
          },
          click: function(swiper) {
            thumbsSwiper.slideTo(swiper.clickedIndex, 500, false);
          },
        },
      });
    }
  }
});